import en from './en.json';
import hu from './hu.json';

export default {
    en: useNamespace(en),
    hu: useNamespace(hu),
};

/**
 * We need to use 'translation' key as the namespace for i18n as a default namespace
 */
function useNamespace(data: Record<string, string | Record<string, string>>) {
    return { translation: data };
}
